import TripDetails from "./tripDetails"

export default TripDetails